// デザイン加工
document.querySelectorAll('.processing__item').forEach(img => {
    img.addEventListener('click', function() {
        const popupId = this.dataset.popup; 
        document.getElementById(popupId).classList.add('show');
        document.body.classList.add('no-scroll'); // スクロール禁止
    });
});
// 閉じるボタン
document.querySelectorAll('.processing__popup-close').forEach(btn => {
    btn.addEventListener('click', function() {
        this.closest('.processing__popup').classList.remove('show');
        document.body.classList.remove('no-scroll'); // スクロール復活
    });
});
// ポップアップ背景クリックでも閉じる
document.querySelectorAll('.processing__popup').forEach(popup => {
    popup.addEventListener('click', function(e) {
        // 背景（自分自身）をクリックした場合のみ閉じる
        if (e.target === popup) {
            popup.classList.remove('show');
            document.body.classList.remove('no-scroll'); // スクロール復活
        }
    });
});